import React from "react";

const ReceiveSecondaryIcon = React.forwardRef(
  (
    {
      variant = "solid",          
      width,                     
      height,
      brandColor = "#5062F0",     
      outlineColor = "#D0D3E2",   
      className,
      ...props
    },
    ref
  ) => {
    const isSolid = variant === "solid";
    const w = width ?? (isSolid ? 18 : 16);
    const h = height ?? (isSolid ? 19 : 16);

    return (
      <svg
        ref={ref}
        width={w}
        height={h}
        viewBox={isSolid ? "0 0 18 19" : "0 0 16 16"}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        aria-hidden="true"
        {...props}
      >
        {isSolid ? (
          <>
            <path
              d="M2 2C2 0.89543 2.89543 0 4 0H14C15.1046 0 16 0.895431 16 2V17H2V2Z"
              fill={brandColor}
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M9 3C9.27614 3 9.5 3.20987 9.5 3.46875V11.7121L12.8131 8.60604C13.0084 8.42299 13.325 8.42299 13.5202 8.60604C13.7155 8.7891 13.7155 9.0859 13.5202 9.26896L9.35355 13.1752C9.15829 13.3583 8.84171 13.3583 8.64645 13.1752L4.47978 9.26896C4.28452 9.0859 4.28452 8.7891 4.47978 8.60604C4.67504 8.42299 4.99162 8.42299 5.18689 8.60604L8.5 11.7121V3.46875C8.5 3.20987 8.72386 3 9 3ZM1.5 12.375C1.77614 12.375 2 12.5849 2 12.8438V15.9688C2 16.2588 2.12292 16.537 2.34171 16.7421C2.5605 16.9473 2.85725 17.0625 3.16667 17.0625H14.8333C15.1428 17.0625 15.4395 16.9473 15.6583 16.7421C15.8771 16.537 16 16.2588 16 15.9688V12.8438C16 12.5849 16.2239 12.375 16.5 12.375C16.7761 12.375 17 12.5849 17 12.8438V15.9688C17 16.5075 16.7717 17.0241 16.3654 17.4051C15.9591 17.786 15.408 18 14.8333 18H3.16667C2.59203 18 2.04093 17.786 1.6346 17.4051C1.22827 17.0241 1 16.5075 1 15.9688V12.8438C1 12.5849 1.22386 12.375 1.5 12.375Z"
              fill="#FFFFFF"
              stroke="#FFFFFF"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </>
        ) : (
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 0C8.27614 0 8.5 0.223858 8.5 0.5V9.29289L11.8131 5.97978C12.0084 5.78452 12.325 5.78452 12.5202 5.97978C12.7155 6.17504 12.7155 6.49162 12.5202 6.68689L8.35355 10.8536C8.15829 11.0488 7.84171 11.0488 7.64645 10.8536L3.47978 6.68689C3.28452 6.49162 3.28452 6.17504 3.47978 5.97978C3.67504 5.78452 3.99162 5.78452 4.18689 5.97978L7.5 9.29289V0.5C7.5 0.223858 7.72386 0 8 0ZM0.5 10C0.776142 10 1 10.2239 1 10.5V13.8333C1 14.1428 1.12292 14.4395 1.34171 14.6583C1.5605 14.8771 1.85725 15 2.16667 15H13.8333C14.1428 15 14.4395 14.8771 14.6583 14.6583C14.8771 14.4395 15 14.1428 15 13.8333V10.5C15 10.2239 15.2239 10 15.5 10C15.7761 10 16 10.2239 16 10.5V13.8333C16 14.408 15.7717 14.9591 15.3654 15.3654C14.9591 15.7717 14.408 16 13.8333 16H2.16667C1.59203 16 1.04093 15.7717 0.634602 15.3654C0.228273 14.9591 0 14.408 0 13.8333V10.5C0 10.2239 0.223858 10 0.5 10Z"
            fill={outlineColor}
          />
        )}
      </svg>
    );
  }
);

export default React.memo(ReceiveSecondaryIcon);
